import { WhatsApp } from './views/whatsapp/WhatsApp';
import { ColdEmail } from './views/coldemail/ColdEmail';
import { ColdCalling } from './views/coldcall/ColdCalling';
import { Automations } from './views/automations/Automations';
import { Navigate, Route, Routes } from 'react-router-dom';
import { VIEWS, type ViewId } from '@ouradent/shared';
import { SetPassword, SignIn } from './auth/SignIn';
import { useSession } from './auth/SessionProvider';
import { AppShell } from './shell/AppShell';
import { Integrations } from './views/Integrations';
import { Calendar } from './views/calendar/Calendar';
import { Placeholder } from './views/Placeholder';
import { Pipeline } from './views/Pipeline';
import { Playbook } from './views/Playbook';
import { Tasks } from './views/tasks/Tasks';
import { Team } from './views/Team';
import { Today } from './views/Today';
import { Calls } from './views/calls/Calls';

export function App() {
  const { loading, session, me, can, needsPassword, passwordSet, signOut } = useSession();

  if (loading) {
    return (
      <main className="grid min-h-screen place-items-center" aria-busy="true">
        <p className="text-muted">Loading…</p>
      </main>
    );
  }

  if (!session) return <SignIn />;
  if (needsPassword) return <SetPassword onDone={passwordSet} />;

  if (!me) {
    return (
      <main className="grid min-h-screen place-items-center p-6">
        <div className="card max-w-md p-7">
          <h1 className="text-2xl font-bold">Waiting for approval</h1>
          <p className="mt-2 text-muted">
            Your account is created. Viliam or Andrej approves it and gives you access, then this
            page opens the app. They have been told.
          </p>
          <button className="btn mt-5" onClick={() => void signOut()}>
            Sign out
          </button>
        </div>
      </main>
    );
  }

  // Land on the first screen this person is actually allowed to open.
  const home = VIEWS.find((view) => can(view.perm))?.id;

  return (
    <Routes>
      <Route element={<AppShell />}>
        {VIEWS.filter((view) => can(view.perm)).map((view) => (
          <Route key={view.id} path={`/${view.id}`} element={screen(view.id)} />
        ))}
      </Route>
      <Route path="*" element={home ? <Navigate to={`/${home}`} replace /> : <NoScreens />} />
    </Routes>
  );
}

function NoScreens() {
  return (
    <main className="grid min-h-screen place-items-center p-6">
      <div className="card max-w-md p-7">
        <h1 className="text-2xl font-bold">Nothing to show</h1>
        <p className="mt-2 text-muted">
          You have no screens switched on. An owner can change that on Team &amp; access.
        </p>
      </div>
    </main>
  );
}

function screen(id: ViewId) {
  switch (id) {
    case 'today':
      return <Today />;
    case 'calls':
      return <Calls />;
    case 'pipeline':
      return <Pipeline />;
    case 'tasks':
      return <Tasks />;
    case 'team':
      return <Team />;
    case 'playbook':
      return <Playbook />;
    case 'integrations':
      return <Integrations />;
    case 'calendar':
      return <Calendar />;
    case 'automations':
      return <Automations />;
    case 'coldcall':
      return <ColdCalling />;
    case 'coldemail':
      return <ColdEmail />;
    case 'whatsapp':
      return <WhatsApp />;
    default:
      return <Placeholder view={id} />;
  }
}
